/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateLog = /* GraphQL */ `
  subscription OnCreateLog {
    onCreateLog {
      id
      createdAt
      app
      action
      actionBy
      actionOn
      currVal
      newVal
      ipAddress
      browserDetails
      userAgent
      a360id
      cif
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLog = /* GraphQL */ `
  subscription OnUpdateLog {
    onUpdateLog {
      id
      createdAt
      app
      action
      actionBy
      actionOn
      currVal
      newVal
      ipAddress
      browserDetails
      userAgent
      a360id
      cif
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLog = /* GraphQL */ `
  subscription OnDeleteLog {
    onDeleteLog {
      id
      createdAt
      app
      action
      actionBy
      actionOn
      currVal
      newVal
      ipAddress
      browserDetails
      userAgent
      a360id
      cif
      updatedAt
      __typename
    }
  }
`;
export const onCreateIp = /* GraphQL */ `
  subscription OnCreateIp {
    onCreateIp {
      address
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateIp = /* GraphQL */ `
  subscription OnUpdateIp {
    onUpdateIp {
      address
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteIp = /* GraphQL */ `
  subscription OnDeleteIp {
    onDeleteIp {
      address
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRestricted = /* GraphQL */ `
  subscription OnCreateRestricted {
    onCreateRestricted {
      a360id
      attempts
      lastAttempt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRestricted = /* GraphQL */ `
  subscription OnUpdateRestricted {
    onUpdateRestricted {
      a360id
      attempts
      lastAttempt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRestricted = /* GraphQL */ `
  subscription OnDeleteRestricted {
    onDeleteRestricted {
      a360id
      attempts
      lastAttempt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateDocument = /* GraphQL */ `
  subscription OnCreateDocument {
    onCreateDocument {
      id
      documentId
      name
      container
      lob
      filterType
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDocument = /* GraphQL */ `
  subscription OnUpdateDocument {
    onUpdateDocument {
      id
      documentId
      name
      container
      lob
      filterType
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDocument = /* GraphQL */ `
  subscription OnDeleteDocument {
    onDeleteDocument {
      id
      documentId
      name
      container
      lob
      filterType
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
